import isFunction from "ramda-extension/es/isFunction";
const identity = (x)=>x;
export function createAction(type, payloadCreator, metaCreator) {
    const finalPayloadCreator = !payloadCreator ? identity : (head, ...args)=>head instanceof Error ? head : payloadCreator(head, ...args);
    const actionCreator = (...args)=>{
        const payload = finalPayloadCreator(...args);
        const action = {
            type
        };
        if (payload instanceof Error) {
            action.error = true;
        }
        if (payload !== undefined) {
            action.payload = payload;
        }
        if (metaCreator) {
            action.meta = metaCreator(...args);
        }
        return action;
    };
    return actionCreator;
}
export const ACTION_TYPE_DELIMITER = '||';
export function handleAction(type, reducer = identity, defaultState) {
    const types = type.split(ACTION_TYPE_DELIMITER);
    const [nextReducer, throwReducer] = isFunction(reducer) ? [
        reducer,
        reducer
    ] : [
        reducer.next,
        reducer.throw
    ].map((aReducer)=>aReducer ?? identity);
    return (state = defaultState, action)=>{
        const { type: actionType } = action;
        if (!actionType || !types.includes(actionType)) {
            return state;
        }
        return (action.error === true ? throwReducer : nextReducer)(state, action);
    };
}
function reduceReducers(initialState, ...reducers) {
    return (prevState, value, ...args)=>{
        const prevStateIsUndefined = typeof prevState === 'undefined';
        const valueIsUndefined = typeof value === 'undefined';
        if (prevStateIsUndefined && valueIsUndefined && initialState) {
            return initialState;
        }
        return reducers.reduce((newState, reducer, index)=>{
            if (typeof reducer === 'undefined') {
                throw new TypeError(`An undefined reducer was passed in at index ${index}`);
            }
            return reducer(newState, value, ...args);
        }, prevStateIsUndefined && !valueIsUndefined && initialState ? initialState : prevState);
    };
}
export function handleActions(handlers, defaultState) {
    const reducers = Object.keys(handlers).map((type)=>handleAction(type, handlers[type], defaultState));
    const reducer = reduceReducers(defaultState, ...reducers);
    return (state = defaultState, action)=>reducer(state, action);
}
export default {
    createAction,
    handleAction,
    handleActions
};
